import { render, staticRenderFns } from "./QuestionNotes.vue?vue&type=template&id=65f76e0f&scoped=true&"
import script from "./QuestionNotes.vue?vue&type=script&lang=ts&"
export * from "./QuestionNotes.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionNotes.vue?vue&type=style&index=0&id=65f76e0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f76e0f",
  null
  
)

export default component.exports